import React, { useEffect, useRef, useState } from "react";
import { ConversationsBubbleType } from "../../../../libraries/types_interface/chats/ChatsTypes";
import AppTheme from "../../../../service/app_config/AppTheme";
import { IconCircleFilledIcon } from "../../../../widget/common/ui/Icon";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";

const BubbleAudio: React.FC<ConversationsBubbleType> = ({
  message,
  audioRangeWidth = 180,
  longPressStatus = false,
}) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  //const [isStopped, setIsStopped] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const [audioLength, setAudioLength] = useState<number>(0);
  const [progress, setProgress] = useState(0); // 0-100

  const audioFile = message.split("|")[0];

  const togglePlay = () => {
    if (!longPressStatus) {
      const audio = audioRef.current;
      if (!audio) return;

      if (isPlaying) {
        audio.pause();
      } else {
        // SSTOP ALL AUDIO PLAYING
        UtilityHelper.stopAllAudio();

        audio.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleSliderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const audio = audioRef.current;
    if (!audio) return;

    const newTime = (parseFloat(event.target.value) / 100) * audio.duration;
    audio.currentTime = newTime;
    setProgress(parseFloat(event.target.value));
  };

  const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return Number.isNaN(secs)
      ? "00:00"
      : `${minutes.toString().padStart(2, "0")}:${
          secs < 10 ? "0" + secs : secs
        }`;
  };

  // Check audio state whenever it changes
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const handleLoaded = () => {
      //console.log("Audio length:", audio.duration); // seconds
      setAudioLength(audio.duration);
    };

    const updateProgress = () => {
      const currentProgress = (audio.currentTime / audio.duration) * 100;
      setProgress(currentProgress || 0);
    };

    const updateStatus = () => {
      //const stopped = audio.paused && audio.currentTime === 0;
      //setIsStopped(stopped);
      setIsPlaying(!audio.paused && !audio.ended);
    };

    audio.addEventListener("play", updateStatus);
    audio.addEventListener("pause", updateStatus);
    audio.addEventListener("ended", updateStatus);
    audio.addEventListener("timeupdate", updateStatus);
    audio.addEventListener("timeupdate", updateProgress);
    audio.addEventListener("loadedmetadata", handleLoaded);

    // Clean up listeners when component unmounts
    return () => {
      audio.removeEventListener("play", updateStatus);
      audio.removeEventListener("pause", updateStatus);
      audio.removeEventListener("ended", updateStatus);
      audio.removeEventListener("timeupdate", updateStatus);
      audio.removeEventListener("timeupdate", updateProgress);
      audio.removeEventListener("loadedmetadata", handleLoaded);
    };
  }, []);

  return (
    <div className="bubble-audio d-flex align-items-center audio-slider">
      <IconCircleFilledIcon
        size={35}
        name={isPlaying ? "audio_pause" : "audio_play"}
        color={AppTheme.white}
        handleClick={togglePlay}
      />
      <div className="ps-2 w-100">
        <audio ref={audioRef} src={audioFile} preload="auto" />
        {/* <button onClick={togglePlay}>
          {isPlaying ? "⏸ Pause" : "▶️ Play"}
        </button> */}

        <input
          type="range"
          min={0}
          max={100}
          step={0.1}
          value={progress}
          onChange={handleSliderChange}
          style={{ width: audioRangeWidth }}
        />

        <div className="pt-2 ps-1 font-gotham-book font-size-10_12 color-black">
          {audioRef.current &&
            isPlaying &&
            formatTime(Math.floor(audioRef.current.currentTime))}

          {!isPlaying && formatTime(Math.floor(audioLength))}

          {/* {audioRef.current &&
            `${Math.floor(audioRef.current.currentTime)} / ${Math.floor(
              audioRef.current.duration || 0
            )} sec`} */}
        </div>

        {/* <div style={{ marginTop: 10 }}>
          {isStopped ? "🟥 Stopped" : isPlaying ? "🟢 Playing" : "⏸ Paused"}
        </div> */}
      </div>
    </div>
  );
};

export default BubbleAudio;
